import request from 'superagent'

export function camelize(text) {
  const a = text.toLowerCase()
      .replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');
  return a.substring(0, 1).toLowerCase() + a.substring(1);
}

export function formatFloat(number, currency = false, decimals = 2) {
  const formatted = parseFloat(number).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true,
  })
  if (currency) {
    return formatted.replace(/,/g, ' ').replace('.', ',') + ' €'
  } else {
    return formatted.replace(/,/g, ' ').replace('.', ',')
  }
}

export function cleanFloat(number) {
  return (parseFloat(number.toString().replace(',', '.').replace('€', '').replace(' ', '').trim()) || 0)
}


// Copies the given values into a DataTables `data:` object, omitting the ones a select returns when
// it has no value. ⚠️ DataTables 2+ serialises an `undefined` value as the literal string
// "undefined", where jQuery's $.param dropped the key — the server then filtered on
// business_unit_id: ["undefined"] and matched nothing, with no exception and no console error
// (UPGRADE_TODO 10.5l). Harmless on the 1.13 we run today; it is what makes the next major safe.
export function assignPresent(target, values) {
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null) target[key] = value
  })

  return target
}

function readAppContext() {
  const meta = document.querySelector('meta[name="app-context"]');
  if (!meta) return { user: null };
  try { return JSON.parse(meta.content); } catch { return { user: null }; }
}

const APP = readAppContext();

export const currentUser = () => APP.user;
export const currentUserRole = () => (APP.user ? APP.user.role : null);
export const isRole = (role) => currentUserRole() === role;

